import { Paper, PaperProps, styled } from '@mui/material';
import { forwardRef } from 'react';

import { doNotForwardTheseProps, elevationLevel } from '@/styles';

import {
  ModalSize,
  ModalSizeValue,
  ModalSizeValueMap,
} from './Modal.constants';

export const ModalContainer = styled(
  forwardRef<HTMLDivElement, PaperProps & { size?: ModalSize }>(
    (props, ref) => <Paper ref={ref} elevation={elevationLevel.l} {...props} />,
  ),
  {
    shouldForwardProp: doNotForwardTheseProps('size'),
  },
)(({ theme, size = 'sm' }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  padding: theme.spacing(3),
  paddingBottom: theme.spacing(5),
  width: size ? ModalSizeValueMap[size] : ModalSizeValueMap[ModalSizeValue.SM],
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  [theme.breakpoints.up('lg')]: {
    width: size
      ? ModalSizeValueMap[size]
      : ModalSizeValueMap[ModalSizeValue.LG],
  },
}));
